import { combineReducers } from 'redux';
import { firebaseStateReducer } from 'react-redux-firebase';

import { imageModal } from './image';
import { squadModal } from './squad';

const rootReducer = combineReducers({
  firebase: firebaseStateReducer,

  // modals.
  imageModal,
  squadModal,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js